const global = {
  init: () => {

    global_accordions();
    global_modals();
    global_scrollto();

    function global_accordions() {
      $(document).on('click', '.dd-trigger', function(){
        var key = $(this).attr('key');
        if ($('.dd-container[key="' + key + '"]').hasClass('open')) {
          $('.dd-container').removeClass('open');
        }
        else {
          $('.dd-container').removeClass('open');
          $('.dd-container[key="' + key + '"]').toggleClass('open');
        }

      });
    }

    function global_scrollto() {
      $('a.scrollto').click(function(){
        $('.modal-overlay.modal-open').removeClass('modal-open');
        $('html, body').animate({
          scrollTop: $( $(this).attr('href') ).offset().top
        }, 500);
        return false;
      });
    }

    function global_modals() {
      $(document).on('click', '.modal-trigger', function(e) {
        var id = $(this).attr('modal');
        $('.modal-overlay[modal="' + id + '"]').addClass('modal-open');
      });
      $(document).on('click', '.modal-close-button, .modal-overlay, .close-modal', function(e) {
        $('.modal-overlay').removeClass('modal-open');
      });
    }

    // make entire slide clickable without changing structure overmuch
    $('.our-products-slider .our-products-product').click(function() {
      window.location = $(this).data("prod-url");
      return false;
    });
    $('.our-products-slider .wc-products-product').click(function() {
      window.location = $(this).data("prod-url");
      return false;
    });

    $(document).on('click', '.page-ac-entry-trigger, .page-ac-sweepstakes-win-cta-text span', function(e) {
      $('body').addClass('ac-entry-modal-open');
    });
    $(document).on('click', '.page-ac-entry-modal-overlay, .modal-close', function(e) {
      $('body').removeClass('ac-entry-modal-open');
    });
    $(document).on('click', '.page-ac-collectors-item-product-buy-box .pdp-qty-minus', function() {
      var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
      if ($current_value > 1) {
        var $new_value = $current_value - 1;
        $(this).parent().find('.pdp-qty-input').val($new_value);
      }
    });
    $(document).on('click', '.page-ac-collectors-item-product-buy-box .pdp-qty-plus', function() {
      var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
      var $new_value = $current_value + 1;
      $(this).parent().find('.pdp-qty-input').val($new_value);
    });

    $(document).on('click', '.page-rm-entry-trigger, .page-sp-entry-trigger, .page-sp-sweepstakes-win-cta-text span', function(e) {
      $('body').addClass('sp-entry-modal-open');
    }); 
    $(document).on('click', '.page-rm-entry-modal-overlay, .page-sp-entry-modal-overlay, .modal-close', function(e) {
      $('body').removeClass('sp-entry-modal-open');
    }); 
    $(document).on('click', '.page-sp-buybox-product-buy-box .pdp-qty-minus', function() {
      var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
      if ($current_value > 1) {
        var $new_value = $current_value - 1;
        $(this).parent().find('.pdp-qty-input').val($new_value);
      }
    });
    $(document).on('click', '.page-sp-buybox-product-buy-box .pdp-qty-plus', function() {
      var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
      var $new_value = $current_value + 1;
      $(this).parent().find('.pdp-qty-input').val($new_value);
    });


    /* Override ShoppingGives */
    function overrideCause()
    {
        const causesAll = document.querySelectorAll(`.sg-roundup-cause, .sg-addon-cause`),
              causeVC   = 'Seedlings for Sustainability';

        if (causesAll.length > 0)
        {
            causesAll.forEach((cause) => {
                if (cause.textContent != causeVC)
                {
                    // console.log(`Cause doesn't match: ${cause.textContent}`);
                    cause.textContent = causeVC;
                }
            })
        }
    }

    const overrideIntervalId = setInterval(overrideCause, 500);

  }
};
export default global;
